// this is an autogenerated file from App/Account/UserNotifications/data.graphql
import { gql } from 'Data/Api'

export default gql`
subscription app__App_Account_UserNotifications{
  notifications_users(
    where: {
      status: { _eq: UNREAD }
      _not: { notification: { tags: { _contains: "inbox" } } }
    }
    order_by: { updated_at: desc }
  ) {
    id
    notification_id
    status
  }
}

`